import { PROVIDERS_MAP } from 'common/constants/constants';
import { FILTER_TYPES } from 'common/constants/filters';
import { useSelector } from 'react-redux';
import { licenseSelector } from 'state/selectors/license';

const DEFAULT_MAX_SELECTED_ENTITIES_ALLOWED = Infinity;

const ENTITIES_MAP = {
  [PROVIDERS_MAP.jira.entity_names.board]: FILTER_TYPES.BOARD,
  [PROVIDERS_MAP.jira.entity_names_plural.board]: FILTER_TYPES.BOARD,
  [PROVIDERS_MAP.jira.entity_names.project]: FILTER_TYPES.PROJECTS,
  [PROVIDERS_MAP.jira.entity_names_plural.project]: FILTER_TYPES.PROJECTS
};

const useEntitiesLimitation = entityType => {
  const license = useSelector(licenseSelector);

  const maxEntitiesMap = {
    [FILTER_TYPES.BOARD]: license?.maxBoards,
    [FILTER_TYPES.PROJECTS]: license?.maxProjects
  };
  const entitiesDeviation = entities => {
    return (
      entities.length -
      (maxEntitiesMap[ENTITIES_MAP[entityType]] ||
        DEFAULT_MAX_SELECTED_ENTITIES_ALLOWED)
    );
  };

  const entitiesLimit =
    maxEntitiesMap[ENTITIES_MAP[entityType]] ||
    DEFAULT_MAX_SELECTED_ENTITIES_ALLOWED;

  return { entitiesDeviation, entitiesLimit };
};

export default useEntitiesLimitation;
